import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  ITargetedCatalogItem,
  targetedCatalogActionCreators,
  TargetedCatalogActionKeys,
  UpdateTargetedCatalogItemOrder
} from '..';
import { IState } from '../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateItem } from '../targetedCatalogApi';
import { ITargetedCatalogGroup } from '../targetedCatalogInterfaces';

function* updateTargetedCatalogItemOrderSaga(action: UpdateTargetedCatalogItemOrder) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<ITargetedCatalogItem[]> = yield call(updateItem, action.payload);
  const currentGroup: ITargetedCatalogGroup = yield select(
    (state: IState) => state.targetedCatalog.groups[action.payload.preseasonCatalogItemGroupId]
  );

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(targetedCatalogActionCreators.setItemGroups([{ ...currentGroup, products: response.value }]));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateTargetedCatalogItemOrder() {
  yield takeEvery(TargetedCatalogActionKeys.UPDATE_TARGETED_CATALOG_ITEM_ORDER, updateTargetedCatalogItemOrderSaga);
}
